import { updateProject } from 'common/api/v1/projects';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    SAVE_PROJECT,
    SAVE_PROJECT_FAILURE,
    SAVE_PROJECT_SUCCESS,
    UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { projectsActions } from '../reducer';
import * as selectors from '../selectors';

export default (values) => (dispatch, getState) => {
    const state = getState();
    const data = selectors.getProjectsData(state);

    if (!values.id) return;

    const newValues = {
        code: values.code,
        name: values.name,
        status: values.status,
    };
    dispatch(projectsActions[SAVE_PROJECT]());

    updateProject(newValues, values.id)
        .then((response) => {
            dispatch(projectsActions[SAVE_PROJECT_SUCCESS](response.data));
            const newItems = data.map((item) => {
                if (item.id === values.id) {
                    return values;
                }
                return item;
            });
            dispatch(projectsActions[UPDATE_ITEMS_SUCCESS](newItems));
            showToast();
        })
        .catch((error) => {
            dispatch(
                projectsActions[SAVE_PROJECT_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
